// GENERATED CODE
// This file is generated by a Python script so do not change it, change the script!
// Script: tools/codegen/generate_tax_fields.py
// Template: tools/codegen/templates/tax_statement_field.ts
import { z } from 'zod';

export const taxStatementFields = [
  'SumEmployersContribution',
  'EstimatedSumEmployersContributionAndSec',
  'BasisEmployersContributionPersonUpTo65',
  'EmployersContributionPersonUpTo65',
  'BasisEmployersContributionPersonAged65to80',
  'EmployersContributionPersonAged65to80',
  'EstimatedEmployersContributionFirstEmployeeAgedAtLeast65',
  'BasisReducedEmployersContributionPersonAged15to18',
  'EstimatedReducedEmployersContributionPersonAged15to18',
  'BasisReducedEmployersContributionPersonAged19to23',
  'EstimatedReducedEmployersContributionPersonAged19to23',
  'BasisEmployersContributionVaxaStodAge19to23',
  'EstimatedEmployersContributionVaxaStodAge19to23',
  'BasisEmployersContributionVaxaStod',
  'EstimatedEmployersContributionVaxaStod',
  'BasisEmployersContributionVaxaStodAtLeast67',
  'EstimatedEmployersContributionVaxaStodAtLeast67',
  'BasisResearchAndDevelopment',
  'DeductionResearchAndDevelopment',
  'BasisRegionalSupport',
  'DeductionRegionalSupport',
  'ReducedFeeFirstEmployee',
  'TaxableGrossSalaryWithoutBenefits',
  'GrossSalary',
  'TaxableBenefits',
  'OtherTaxableBenefits',
  'TaxableVehicleBenefit',
  'VehicleFuelBenefit',
  'OtherReimbursements',
  'BenefitsAdjusted',
  'VehicleAllowance',
  'SubsistenceAllowance',
  'CompensationExemptFromSocialFeesSkvInternal',
  'CompensationExemptFromSocialFees',
  'SumTaxDeductions',
  'EstimatedSumTaxDeductions',
  'PreliminaryTax',
  'TaxDeductionSinkIndividuals',
  'TaxDeductionSink',
  'DecisionNonTaxableInSwedenNoDeduction',
  'PreliminaryWithholdingTaxes',
  'SumSickPayExpensesAndEmployersContribution',
  'ReceiverId',
  'WorkLocationId',
  'CountryCodeNonSwedishCitizenship',
  'SsnOrCorporateId',
  'GivenName',
  'Surname',
  'StreetAddress',
  'ZipCode',
  'City',
  'StreetAddress2',
  'NonFixedAddress',
  'AnnuityOccupationalInjuryBefore1962',
  'BasisTaxDeductionPensionInsurance',
  'BasisTaxDeductionInterestOrDividend',
  'SumTaxDeductionsIndividuals',
  'TaxDeductionPensionInsurance',
  'TaxDeductionInterestOrDividend',
] as const;
export type TaxStatementField = (typeof taxStatementFields)[number];
export const taxStatementFieldSchema = z.enum(taxStatementFields);
export const taxStatementFieldDecoder = (value: unknown): TaxStatementField =>
  taxStatementFieldSchema.parse(value);

export const payeFieldCodes = [
  '487',
  '587',
  '420',
  '430',
  '422',
  '432',
  '431',
  '424',
  '434',
  '7001',
  '9001',
  '7002',
  '9002',
  '7021',
  '9021',
  '7022',
  '9022',
  '470',
  '475',
  '471',
  '476',
  '062',
  '411',
  '011',
  '412',
  '012',
  '013',
  '018',
  '020',
  '048',
  '050',
  '051',
  '460',
  '131',
  '497',
  '597',
  '405',
  '406',
  '274',
  '276',
  '001',
  '499',
  '570',
  '060',
  '081',
  '215',
  '216',
  '217',
  '218',
  '219',
  '220',
  '228',
  '302',
  '421',
  '491',
  '492',
  '494',
  '495',
  '496',
] as const;
export type PayeFieldCode = (typeof payeFieldCodes)[number];

// prettier-ignore
export function getTaxStatementCodeFromField(field: TaxStatementField): PayeFieldCode {
  switch (field) {
    case 'SumEmployersContribution': return '487'
    case 'EstimatedSumEmployersContributionAndSec': return '587'
    case 'BasisEmployersContributionPersonUpTo65': return '420'
    case 'EmployersContributionPersonUpTo65': return '430'
    case 'BasisEmployersContributionPersonAged65to80': return '422'
    case 'EmployersContributionPersonAged65to80': return '432'
    case 'EstimatedEmployersContributionFirstEmployeeAgedAtLeast65': return '431'
    case 'BasisReducedEmployersContributionPersonAged15to18': return '424'
    case 'EstimatedReducedEmployersContributionPersonAged15to18': return '434'
    case 'BasisReducedEmployersContributionPersonAged19to23': return '7001'
    case 'EstimatedReducedEmployersContributionPersonAged19to23': return '9001'
    case 'BasisEmployersContributionVaxaStodAge19to23': return '7002'
    case 'EstimatedEmployersContributionVaxaStodAge19to23': return '9002'
    case 'BasisEmployersContributionVaxaStod': return '7021'
    case 'EstimatedEmployersContributionVaxaStod': return '9021'
    case 'BasisEmployersContributionVaxaStodAtLeast67': return '7022'
    case 'EstimatedEmployersContributionVaxaStodAtLeast67': return '9022'
    case 'BasisResearchAndDevelopment': return '470'
    case 'DeductionResearchAndDevelopment': return '475'
    case 'BasisRegionalSupport': return '471'
    case 'DeductionRegionalSupport': return '476'
    case 'ReducedFeeFirstEmployee': return '062'
    case 'TaxableGrossSalaryWithoutBenefits': return '411'
    case 'GrossSalary': return '011'
    case 'TaxableBenefits': return '412'
    case 'OtherTaxableBenefits': return '012'
    case 'TaxableVehicleBenefit': return '013'
    case 'VehicleFuelBenefit': return '018'
    case 'OtherReimbursements': return '020'
    case 'BenefitsAdjusted': return '048'
    case 'VehicleAllowance': return '050'
    case 'SubsistenceAllowance': return '051'
    case 'CompensationExemptFromSocialFeesSkvInternal': return '460'
    case 'CompensationExemptFromSocialFees': return '131'
    case 'SumTaxDeductions': return '497'
    case 'EstimatedSumTaxDeductions': return '597'
    case 'PreliminaryTax': return '405'
    case 'TaxDeductionSinkIndividuals': return '406'
    case 'TaxDeductionSink': return '274'
    case 'DecisionNonTaxableInSwedenNoDeduction': return '276'
    case 'PreliminaryWithholdingTaxes': return '001'
    case 'SumSickPayExpensesAndEmployersContribution': return '499'
    case 'ReceiverId': return '570'
    case 'WorkLocationId': return '060'
    case 'CountryCodeNonSwedishCitizenship': return '081'
    case 'SsnOrCorporateId': return '215'
    case 'GivenName': return '216'
    case 'Surname': return '217'
    case 'StreetAddress': return '218'
    case 'ZipCode': return '219'
    case 'City': return '220'
    case 'StreetAddress2': return '228'
    case 'NonFixedAddress': return '302'
    case 'AnnuityOccupationalInjuryBefore1962': return '421'
    case 'BasisTaxDeductionPensionInsurance': return '491'
    case 'BasisTaxDeductionInterestOrDividend': return '492'
    case 'SumTaxDeductionsIndividuals': return '494'
    case 'TaxDeductionPensionInsurance': return '495'
    case 'TaxDeductionInterestOrDividend': return '496'
}
}
// prettier-ignore
export function getTaxStatementFieldFromCode(code: PayeFieldCode): TaxStatementField {
  switch (code) {
    case '487': return 'SumEmployersContribution'
    case '587': return 'EstimatedSumEmployersContributionAndSec'
    case '420': return 'BasisEmployersContributionPersonUpTo65'
    case '430': return 'EmployersContributionPersonUpTo65'
    case '422': return 'BasisEmployersContributionPersonAged65to80'
    case '432': return 'EmployersContributionPersonAged65to80'
    case '431': return 'EstimatedEmployersContributionFirstEmployeeAgedAtLeast65'
    case '424': return 'BasisReducedEmployersContributionPersonAged15to18'
    case '434': return 'EstimatedReducedEmployersContributionPersonAged15to18'
    case '7001': return 'BasisReducedEmployersContributionPersonAged19to23'
    case '9001': return 'EstimatedReducedEmployersContributionPersonAged19to23'
    case '7002': return 'BasisEmployersContributionVaxaStodAge19to23'
    case '9002': return 'EstimatedEmployersContributionVaxaStodAge19to23'
    case '7021': return 'BasisEmployersContributionVaxaStod'
    case '9021': return 'EstimatedEmployersContributionVaxaStod'
    case '7022': return 'BasisEmployersContributionVaxaStodAtLeast67'
    case '9022': return 'EstimatedEmployersContributionVaxaStodAtLeast67'
    case '470': return 'BasisResearchAndDevelopment'
    case '475': return 'DeductionResearchAndDevelopment'
    case '471': return 'BasisRegionalSupport'
    case '476': return 'DeductionRegionalSupport'
    case '062': return 'ReducedFeeFirstEmployee'
    case '411': return 'TaxableGrossSalaryWithoutBenefits'
    case '011': return 'GrossSalary'
    case '412': return 'TaxableBenefits'
    case '012': return 'OtherTaxableBenefits'
    case '013': return 'TaxableVehicleBenefit'
    case '018': return 'VehicleFuelBenefit'
    case '020': return 'OtherReimbursements'
    case '048': return 'BenefitsAdjusted'
    case '050': return 'VehicleAllowance'
    case '051': return 'SubsistenceAllowance'
    case '460': return 'CompensationExemptFromSocialFeesSkvInternal'
    case '131': return 'CompensationExemptFromSocialFees'
    case '497': return 'SumTaxDeductions'
    case '597': return 'EstimatedSumTaxDeductions'
    case '405': return 'PreliminaryTax'
    case '406': return 'TaxDeductionSinkIndividuals'
    case '274': return 'TaxDeductionSink'
    case '276': return 'DecisionNonTaxableInSwedenNoDeduction'
    case '001': return 'PreliminaryWithholdingTaxes'
    case '499': return 'SumSickPayExpensesAndEmployersContribution'
    case '570': return 'ReceiverId'
    case '060': return 'WorkLocationId'
    case '081': return 'CountryCodeNonSwedishCitizenship'
    case '215': return 'SsnOrCorporateId'
    case '216': return 'GivenName'
    case '217': return 'Surname'
    case '218': return 'StreetAddress'
    case '219': return 'ZipCode'
    case '220': return 'City'
    case '228': return 'StreetAddress2'
    case '302': return 'NonFixedAddress'
    case '421': return 'AnnuityOccupationalInjuryBefore1962'
    case '491': return 'BasisTaxDeductionPensionInsurance'
    case '492': return 'BasisTaxDeductionInterestOrDividend'
    case '494': return 'SumTaxDeductionsIndividuals'
    case '495': return 'TaxDeductionPensionInsurance'
    case '496': return 'TaxDeductionInterestOrDividend'
}
}

// prettier-ignore
export function translateTaxStatementField(field: TaxStatementField): string {
  switch (field) {
    case 'SumEmployersContribution': return 'Summa arbetsgivaravgifter och SLF'
    case 'EstimatedSumEmployersContributionAndSec': return 'Beräknad summa arbetsgivaravgift och SLF'
    case 'BasisEmployersContributionPersonUpTo65': return 'Underlag arbetsgivaravgifter för 66 år eller yngre vid årets ingång'
    case 'EmployersContributionPersonUpTo65': return 'Arbetsgivaravgifter för 66 år eller yngre'
    case 'BasisEmployersContributionPersonAged65to80': return 'Underlag arbetsgivaravgifter för 67 år eller äldre vid årets ingång'
    case 'EmployersContributionPersonAged65to80': return 'Arbetsgivaravgifter för 67 år eller äldre'
    case 'EstimatedEmployersContributionFirstEmployeeAgedAtLeast65': return 'Beräknad arbetsgivaravgift för först anställd'
    case 'BasisReducedEmployersContributionPersonAged15to18': return 'Underlag nedsatta arbetsgivaravgifter för ålder 15-18år'
    case 'EstimatedReducedEmployersContributionPersonAged15to18': return 'Beräknad nedsatt arbetsgivaravgift för ålder 15-18år'
    case 'BasisReducedEmployersContributionPersonAged19to23': return 'Underlag arbetsgivaravgifter för 18-22 år vid årets ingång'
    case 'EstimatedReducedEmployersContributionPersonAged19to23': return 'Arbetsgivaravgifter för 18-22 år'
    case 'BasisEmployersContributionVaxaStodAge19to23': return 'Underlag reducerad avgift Växa-stöd för 18-22 år vid årets ingång'
    case 'EstimatedEmployersContributionVaxaStodAge19to23': return 'Beräknad arbetsgivaravgift Växa-stöd för 18-22 år'
    case 'BasisEmployersContributionVaxaStod': return 'Underlag reducerad avgift Växa-stöd för 23-66 år vid årets ingång'
    case 'EstimatedEmployersContributionVaxaStod': return 'Beräknad arbetsgivaravgift Växa-stöd för 23-66 år'
    case 'BasisEmployersContributionVaxaStodAtLeast67': return 'Underlag reducerad avgift Växa-stöd för 67 år eller äldre vid årets ingång'
    case 'EstimatedEmployersContributionVaxaStodAtLeast67': return 'Beräknad arbetsgivaravgift Växa-stöd för 67 år eller äldre'
    case 'BasisResearchAndDevelopment': return 'Underlag avdrag för forskning och utveckling'
    case 'DeductionResearchAndDevelopment': return 'Avdrag för forskning och utveckling'
    case 'BasisRegionalSupport': return 'Underlag avdrag för regionalt stöd'
    case 'DeductionRegionalSupport': return 'Avdrag för regionalt stöd'
    case 'ReducedFeeFirstEmployee': return 'Reducerad avgift först anställd'
    case 'TaxableGrossSalaryWithoutBenefits': return 'Avgiftspliktig bruttolön utom förmåner'
    case 'GrossSalary': return 'Kontant bruttolön m.m.'
    case 'TaxableBenefits': return 'Avgiftspliktiga förmåner'
    case 'OtherTaxableBenefits': return 'Övriga skattepliktiga förmåner'
    case 'TaxableVehicleBenefit': return 'Skattepliktig bilförmån'
    case 'VehicleFuelBenefit': return 'Drivmedel vid bilförmån'
    case 'OtherReimbursements': return 'Övriga kostnadsersättningar'
    case 'BenefitsAdjusted': return 'Förmån har justerats'
    case 'VehicleAllowance': return 'Bilersättning'
    case 'SubsistenceAllowance': return 'Traktamente'
    case 'CompensationExemptFromSocialFeesSkvInternal': return 'Ersättningar som inte är underlag för socialavgifter *'
    case 'CompensationExemptFromSocialFees': return 'Ersättning som inte är underlag för sociala avgifter'
    case 'SumTaxDeductions': return 'Summa skatteavdrag'
    case 'EstimatedSumTaxDeductions': return 'Beräknad summa skatteavdrag'
    case 'PreliminaryTax': return 'Avdragen preliminärskatt individuppgifter'
    case 'TaxDeductionSinkIndividuals': return 'Avdragen skatt, SINK, individuppgifter'
    case 'TaxDeductionSink': return 'Avdragen skatt, SINK'
    case 'DecisionNonTaxableInSwedenNoDeduction': return 'Beslut ej skatteavdrag pga. att inkomsten inte ska beskattas i Sverige'
    case 'PreliminaryWithholdingTaxes': return 'Avdragen preliminär skatt'
    case 'SumSickPayExpensesAndEmployersContribution': return 'Sjuklönekostnad inklusive arbetsgivaravgifter'
    case 'ReceiverId': return 'Specifikationsnummer'
    case 'WorkLocationId': return 'Arbetsställenummer'
    case 'CountryCodeNonSwedishCitizenship': return 'Landskod medborgarskap ej svenskt'
    case 'SsnOrCorporateId': return 'Person-/samordnings-/organisationsnummer'
    case 'GivenName': return 'Förnamn'
    case 'Surname': return 'Efternamn'
    case 'StreetAddress': return 'Gatuadress'
    case 'ZipCode': return 'Postnummer'
    case 'City': return 'Postort'
    case 'StreetAddress2': return 'Gatuadress 2'
    case 'NonFixedAddress': return 'Ej fast driftställe i Sverige'
    case 'AnnuityOccupationalInjuryBefore1962': return 'Personskadelivränta, skada inträffad före 1962'
    case 'BasisTaxDeductionPensionInsurance': return 'Underlag skatteavdrag pensionsförsäkring'
    case 'BasisTaxDeductionInterestOrDividend': return 'Underlag skatteavdrag ränta och utdelning'
    case 'SumTaxDeductionsIndividuals': return 'Summa skatteavdrag individuppgifter'
    case 'TaxDeductionPensionInsurance': return 'Skatteavdrag pensionsförsäkring'
    case 'TaxDeductionInterestOrDividend': return 'Skatteavdrag ränta och utdelning'
}
}

export const payeSummaryFields = [
  '411',
  '412',
  '420',
  '421',
  '422',
  '424',
  '430',
  '431',
  '432',
  '434',
  '460',
  '470',
  '471',
  '475',
  '476',
  '487',
  '491',
  '492',
  '494',
  '495',
  '496',
  '497',
  '499',
  '587',
  '597',
  '7002',
  '7021',
  '7022',
  '9002',
  '9021',
  '9022',
] as const;
export type PayeSummaryField = (typeof payeSummaryFields)[number];
export function isPayeSummaryField(arg: unknown): arg is PayeSummaryField {
  return typeof arg === 'string' && payeSummaryFields.includes(arg as PayeSummaryField);
}

export const disabledPayeFields = ['412', '012', '013', '018'] as const;
type DisabledPayeField = (typeof disabledPayeFields)[number];
export function isDisabledPayeField(arg: unknown): arg is DisabledPayeField {
  return typeof arg === 'string' && disabledPayeFields.includes(arg as DisabledPayeField);
}

// prettier-ignore
export const payeBlocks = [
  'Unknown',
] as const;
export type PayeBlock = (typeof payeBlocks)[number];
export function translatePayeBlock(block: PayeBlock): string {
  switch (block) {
    case 'Unknown':
      // TODO#1790: If we have blocks this will be replaced by them, otherwise we will probably have a better translation here. It will show in the upper left corner in the table
      return 'Deklarationsruta';
  }
}

type FieldInfo = {
  description: string;
  block: PayeBlock;
  sortPriority: number;
  showDefault: boolean;
};

// prettier-ignore
export function getPayeFieldInfo(code: PayeFieldCode): FieldInfo {
  switch (code) {
    case '487':
      return { description: 'Summa arbetsgivaravgifter och SLF', block: 'Unknown', sortPriority: 1, showDefault: true };
    case '587':
      return { description: 'Beräknad summa arbetsgivaravgift och SLF', block: 'Unknown', sortPriority: 2, showDefault: false };
    case '420':
      return { description: 'Underlag arbetsgivaravgifter för 66 år eller yngre vid årets ingång', block: 'Unknown', sortPriority: 3, showDefault: true };
    case '430':
      return { description: 'Arbetsgivaravgifter för 66 år eller yngre', block: 'Unknown', sortPriority: 4, showDefault: true };
    case '422':
      return { description: 'Underlag arbetsgivaravgifter för 67 år eller äldre vid årets ingång', block: 'Unknown', sortPriority: 5, showDefault: false };
    case '432':
      return { description: 'Arbetsgivaravgifter för 67 år eller äldre', block: 'Unknown', sortPriority: 6, showDefault: false };
    case '431':
      return { description: 'Beräknad arbetsgivaravgift för först anställd', block: 'Unknown', sortPriority: 7, showDefault: false };
    case '424':
      return { description: 'Underlag nedsatta arbetsgivaravgifter för ålder 15-18år', block: 'Unknown', sortPriority: 8, showDefault: false };
    case '434':
      return { description: 'Beräknad nedsatt arbetsgivaravgift för ålder 15-18år', block: 'Unknown', sortPriority: 9, showDefault: false };
    case '7001':
      return { description: 'Underlag arbetsgivaravgifter för 18-22 år vid årets ingång', block: 'Unknown', sortPriority: 10, showDefault: false };
    case '9001':
      return { description: 'Arbetsgivaravgifter för 18-22 år', block: 'Unknown', sortPriority: 11, showDefault: false };
    case '7002':
      return { description: 'Underlag reducerad avgift Växa-stöd för 18-22 år vid årets ingång', block: 'Unknown', sortPriority: 12, showDefault: false };
    case '9002':
      return { description: 'Beräknad arbetsgivaravgift Växa-stöd för 18-22 år', block: 'Unknown', sortPriority: 13, showDefault: false };
    case '7021':
      return { description: 'Underlag reducerad avgift Växa-stöd för 23-66 år vid årets ingång', block: 'Unknown', sortPriority: 14, showDefault: false };
    case '9021':
      return { description: 'Beräknad arbetsgivaravgift Växa-stöd för 23-66 år', block: 'Unknown', sortPriority: 15, showDefault: false };
    case '7022':
      return { description: 'Underlag reducerad avgift Växa-stöd för 67 år eller äldre vid årets ingång', block: 'Unknown', sortPriority: 16, showDefault: false };
    case '9022':
      return { description: 'Beräknad arbetsgivaravgift Växa-stöd för 67 år eller äldre', block: 'Unknown', sortPriority: 17, showDefault: false };
    case '470':
      return { description: 'Underlag avdrag för forskning och utveckling', block: 'Unknown', sortPriority: 18, showDefault: false };
    case '475':
      return { description: 'Avdrag för forskning och utveckling', block: 'Unknown', sortPriority: 19, showDefault: false };
    case '471':
      return { description: 'Underlag avdrag för regionalt stöd', block: 'Unknown', sortPriority: 20, showDefault: false };
    case '476':
      return { description: 'Avdrag för regionalt stöd', block: 'Unknown', sortPriority: 21, showDefault: false };
    case '062':
      return { description: 'Reducerad avgift först anställd', block: 'Unknown', sortPriority: 22, showDefault: false };
    case '411':
      return { description: 'Avgiftspliktig bruttolön utom förmåner', block: 'Unknown', sortPriority: 23, showDefault: true };
    case '011':
      return { description: 'Kontant bruttolön m.m.', block: 'Unknown', sortPriority: 24, showDefault: false };
    case '412':
      return { description: 'Avgiftspliktiga förmåner', block: 'Unknown', sortPriority: 25, showDefault: true };
    case '012':
      return { description: 'Övriga skattepliktiga förmåner', block: 'Unknown', sortPriority: 26, showDefault: false };
    case '013':
      return { description: 'Skattepliktig bilförmån', block: 'Unknown', sortPriority: 27, showDefault: false };
    case '018':
      return { description: 'Drivmedel vid bilförmån', block: 'Unknown', sortPriority: 28, showDefault: false };
    case '020':
      return { description: 'Övriga kostnadsersättningar', block: 'Unknown', sortPriority: 29, showDefault: false };
    case '048':
      return { description: 'Förmån har justerats', block: 'Unknown', sortPriority: 30, showDefault: false };
    case '050':
      return { description: 'Bilersättning', block: 'Unknown', sortPriority: 31, showDefault: false };
    case '051':
      return { description: 'Traktamente', block: 'Unknown', sortPriority: 32, showDefault: false };
    case '460':
      return { description: 'Ersättningar som inte är underlag för socialavgifter *', block: 'Unknown', sortPriority: 33, showDefault: false };
    case '131':
      return { description: 'Ersättning som inte är underlag för sociala avgifter', block: 'Unknown', sortPriority: 34, showDefault: false };
    case '497':
      return { description: 'Summa skatteavdrag', block: 'Unknown', sortPriority: 35, showDefault: true };
    case '597':
      return { description: 'Beräknad summa skatteavdrag', block: 'Unknown', sortPriority: 36, showDefault: false };
    case '405':
      return { description: 'Avdragen preliminärskatt individuppgifter', block: 'Unknown', sortPriority: 37, showDefault: false };
    case '406':
      return { description: 'Avdragen skatt, SINK, individuppgifter', block: 'Unknown', sortPriority: 38, showDefault: false };
    case '274':
      return { description: 'Avdragen skatt, SINK', block: 'Unknown', sortPriority: 39, showDefault: false };
    case '276':
      return { description: 'Beslut ej skatteavdrag pga. att inkomsten inte ska beskattas i Sverige', block: 'Unknown', sortPriority: 40, showDefault: false };
    case '001':
      return { description: 'Avdragen preliminär skatt', block: 'Unknown', sortPriority: 41, showDefault: false };
    case '499':
      return { description: 'Sjuklönekostnad inklusive arbetsgivaravgifter', block: 'Unknown', sortPriority: 42, showDefault: false };
    case '570':
      return { description: 'Specifikationsnummer', block: 'Unknown', sortPriority: 43, showDefault: false };
    case '060':
      return { description: 'Arbetsställenummer', block: 'Unknown', sortPriority: 44, showDefault: false };
    case '081':
      return { description: 'Landskod medborgarskap ej svenskt', block: 'Unknown', sortPriority: 45, showDefault: false };
    case '215':
      return { description: 'Person-/samordnings-/organisationsnummer', block: 'Unknown', sortPriority: 46, showDefault: false };
    case '216':
      return { description: 'Förnamn', block: 'Unknown', sortPriority: 47, showDefault: false };
    case '217':
      return { description: 'Efternamn', block: 'Unknown', sortPriority: 48, showDefault: false };
    case '218':
      return { description: 'Gatuadress', block: 'Unknown', sortPriority: 49, showDefault: false };
    case '219':
      return { description: 'Postnummer', block: 'Unknown', sortPriority: 50, showDefault: false };
    case '220':
      return { description: 'Postort', block: 'Unknown', sortPriority: 51, showDefault: false };
    case '228':
      return { description: 'Gatuadress 2', block: 'Unknown', sortPriority: 52, showDefault: false };
    case '302':
      return { description: 'Ej fast driftställe i Sverige', block: 'Unknown', sortPriority: 53, showDefault: false };
    case '421':
      return { description: 'Personskadelivränta, skada inträffad före 1962', block: 'Unknown', sortPriority: 54, showDefault: false };
    case '491':
      return { description: 'Underlag skatteavdrag pensionsförsäkring', block: 'Unknown', sortPriority: 55, showDefault: false };
    case '492':
      return { description: 'Underlag skatteavdrag ränta och utdelning', block: 'Unknown', sortPriority: 56, showDefault: false };
    case '494':
      return { description: 'Summa skatteavdrag individuppgifter', block: 'Unknown', sortPriority: 57, showDefault: false };
    case '495':
      return { description: 'Skatteavdrag pensionsförsäkring', block: 'Unknown', sortPriority: 58, showDefault: false };
    case '496':
      return { description: 'Skatteavdrag ränta och utdelning', block: 'Unknown', sortPriority: 59, showDefault: false };
  }
}
